module.exports = __webpack_public_path__ + "img/LogoMicroMarket-2d-completofondo.c57985b1.jpg";